import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import styles from '../../_css/Project.module.css';
import { Card } from '../UI';
import SectionDivider from '../Simulation/SectionDivider';
import FormInput from '../Simulation/FormInput';
import FormTextArea from '../Simulation/FormTextArea';
import SearchableDrp from '../common/SearchableDrp';
import { COUNTRY_OPTIONS } from '../Simulation/constants';
import { notifyError } from '../../utils/helper';

const CreateProject = ({ onBack, onSaveAndGo }) => {
  const { brand_id, brand_name } = useSelector((state) => state.context);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    projectName: '',
    description: '',
    country: '',
    brand_id: brand_id ?? '',
  });
  const updateForm = (k, v) => setForm((p) => ({ ...p, [k]: v }));

  const { projectName, description, country } = form;

  const submitHandler = async () => {
    if (!projectName) {
      notifyError('Please enter a project name');
      return;
    }
    if (projectName.length < 2) {
      notifyError('Project name must be at least 2 characters long');
      return;
    }
    if (projectName.length > 50) {
      notifyError('Project name must be less than 30 characters long');
      return;
    }

    if (!country) {
      notifyError('Please select a country');
      return;
    }
    if (!brand_id) {
      notifyError('Please select a brand');
      return;
    }
    setLoading(true);
    await onSaveAndGo(form);
    setLoading(false);

  }

  const formContent = (
    <>
      <SectionDivider label="Project Details" variant="light" />
      <FormInput
        variant="light"
        label="Project Name"
        placeholder="e.g., E.ON Sustainable Energy"
        helpText="Use a descriptive name: Client + Topic works well."
        icon="📋"
        required
        value={projectName}
        onChange={(v) => updateForm('projectName', v)}
        minLength={2}
        maxLength={50}
      />
      <FormTextArea
        variant="light"
        label="Project Description"
        placeholder="e.g., Focus on premium homeowners aged 30-55 in urban Germany who are considering switching to renewable energy providers. Key differentiator: E.ON's integrated smart home + energy bundle."
        helpText="Optional, but recommended. This context is used in the simulation prompt — the more specific you are about target audience, market positioning, or competitive angle, the better the results."
        value={description}
        onChange={(v) => updateForm('description', v)}
      />

      <FormInput
        variant="light"
        label="Brand"
        placeholder="—"
        helpText="Current brand from your session context. This project will be created under this brand."
        icon="🏷️"
        required={true}
        value={brand_name || ''}
        readOnly
      />

      <div className={styles.fieldSpacer}>
        <label className={styles.lightFormLabel}>
          Country / Market <span className={styles.requiredAsterisk}>*</span>
        </label>
        <SearchableDrp
          options={COUNTRY_OPTIONS}
          value={country}
          onChange={(v) => updateForm('country', v)}
          placeholder="Select a country..."
          icon="🌍"
        />
        <p className={styles.helpText}>
          The target market or country for this project. Only markets covered by GWI are listed.
        </p>
      </div>

      <div className={styles.formActions}>
        <button
          type="button"
          disabled={loading}
          onClick={submitHandler}
          className={styles.btnPrimary}
        >
          {loading ? 'Creating Project...' : 'Create Project'}
        </button>
      </div>
    </>
  );


  return (
    <div className={styles.page}>
      <div className={styles.pageHeader}>
        <div className={styles.pageHeaderLeft}>
          <button type="button" onClick={onBack} className={styles.backBtn}>
            ← Back to Projects
          </button>
          <div>
            <h1 className={`${styles.pageTitle} ${styles.pageTypeBrand}`}>
              Create New Project
            </h1>
            <p className={`${styles.pageSubtitle} ${styles.pageTypeBrand}`}>
              Fields marked with <span className={styles.requiredAsterisk}>*</span> are required
            </p>
          </div>
        </div>
      </div>
      <div className={styles.formCard}>
        <Card>{formContent}</Card>
      </div>
    </div>
  );
};

export default CreateProject;
